import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export interface ReplayProgressEvent {
  index: number;
  progress: number; // 0–100
}

@Component({
  selector: 'app-replay-progress',
  templateUrl: './replay-progress.component.html',
  styleUrls: ['./replay-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ReplayProgressComponent {
  readonly progressEvent = input.required<ReplayProgressEvent>();
  readonly totalSegments = input.required<number>();

  // Computed fill levels
  fillLevels = computed(() => {
    const { index, progress } = this.progressEvent();
    const total = this.totalSegments();

    const levels: number[] = new Array(total).fill(0);

    for (let i = 0; i < index && i < total; i++) {
      levels[i] = 100;
    }

    if (index >= 0 && index < total) {
      levels[index] = Math.max(0, Math.min(progress, 100));
    }

    return levels;
  });
}
